import React, { useEffect, useRef, useState } from "react";

import ListUI from "./DesignElements/ListUI";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
  BotMessageSquare,
  Dices,
  CopyPlus,
  CornerUpLeftIcon,
  CornerUpRight,
  Trash2,
  CornerRightUp,
  CornerLeftDown,
  Pencil,
  ChartBar,
  CheckIcon,
  CheckCheck} from 'lucide-react';

const UIBlockRenderer = ({ moveItemUp,moveItemDown,deleteItem,duplicateItem,currentIndex,item ,dynamicId,setCurrentObject,
}) => {  
    
     const dispatch = useDispatch();
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
    const [reloadItems, setReloadItems] = useState(true);

    useEffect(()=>{
        setReloadItems(false); setReloadItems(true)
    },[ currentIndex,item?.myKey]
)
    const extractElementType = (str) => {
  const match = str?.match(/^.*?-(.*?)-.*$/);
  return match ? match[1] : null;
};



  return (<div> {
      reloadItems&& <div> <div className="showPlusElementOuter"  > <div className="showPlusElement"  onMouseEnter={
                        ()=>handleMouseEnter("","","")}
        onMouseLeave={handleMouseLeave} style={{background:dynamicId==item?.myKey?"":""}}><div style={{padding:"5px",marginTop:"-19px",width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.41)"}} ><Plus size={23} style={{width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.941)"}} color="#ffffff" /></div></div></div>
     {dynamicId==item?.myKey? <div className="" style={{position:"absolute",top:"-14px",left:"3px",fontSize:"12px",width:"73px",height:"25px",borderRadius:"5px"}}> <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}}><div className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",position:"absolute",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"60px",height:"15px",paddingRight:"5px",}}> <CheckCheck size={12}  color="#333" /> Selected</div></div></div>:
        
           <div className="showElementSettingsLeft" style={{position:"absolute",top:"-17px",width:"27px",height:"28px",}}> <div style={{position:"absolute",top:"1px",left:"0px",right:"0px",bottom:"0px"}}> <div className="ElementSettingsItem"  onClick={()=>{setCurrentObject(item?.myKey,item);}} style={{display:"flex",justifyContent:"space-between",position:"absolute",fontSize:"12px",padding:"3px",left:"-1px"}}> <Pencil size={18}  color="#333" /></div></div> </div>}  
    
      <div className="showElementSettings" style={{}}> 
        <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
        <div className="ElementSettingsItem" style={{position:"relative",left:"-1px"}} onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Move Up")}
        onMouseLeave={handleMouseLeave}
        
        onClick={()=>{moveItemUp(item)}}
        >
      <CornerRightUp size={18}  color="#444" />
      </div> </div>   <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
        <div className="ElementSettingsItem"style={{position:"relative",left:"-1px"}} onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Move Down")}
        onMouseLeave={handleMouseLeave}
        
          onClick={()=>{moveItemDown(item)}}>
      <CornerLeftDown size={18}  color="#444" />
      </div> </div>  <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
        <div className="ElementSettingsItem" style={{position:"relative",left:"-1px"}} onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Duplicate element")}
        onMouseLeave={handleMouseLeave}
         onClick={()=>{duplicateItem(item)}}>
      <CopyPlus size={18}  color="#444" />
      </div></div>  <div style={{position:"relative",top:"1px",left:"0px",width:"27px",right:"0px",bottom:"0px"}}> 
      <div className="ElementSettingsItem" style={{position:"relative",left:"-1px"}} 
      onMouseEnter={
                        ()=>handleMouseEnter("rgba(144, 202, 249,1) "," #ffffff","Delete element")}
        onMouseLeave={handleMouseLeave}
         onClick={()=>{deleteItem(item)}}
        >
      <Trash2 size={18}  color="#444" />
      </div>
      </div></div></div>}
        {
      reloadItems&&  extractElementType(item?.myKey)=="list1"?  <ListUI
       CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={item?.myKey} 
            setCurrentObject={()=>{setCurrentObject(item?.myKey,item);}}
           
           

// 
//  scrollItems={scrollItems} setScrollItems={(val)=>setScrollItems(val)}
//              columnsList={columnsList} setColumnsList={(val)=>{setColumnsList(val) }} 
//   fontFamily={fontFamily} setFontFamily={(val)=>{setFontFamily(val)}} fontWeight={fontWeight} setFontWeight={(val)=>{setFontWeight(val)}}
//     iWidth={iWidth} setiWidth={(val)=>{}} iHeight={iHeight} setiHeight={(val)=>{setiHeight(val)}}
//     titleFontSize={titleFontSize} setTitleFontSize={(val)=>{setTitleFontSize(val)}} 
//     subTitleFontSize={subTitleFontSize} setSubTitleFontSize={(val)=>{setSubTitleFontSize(val)}}
//     titleFontColor={titleFontColor} setTitleFontColor={(val)=>{setTitleFontColor(val)}} 
//     subTitleFontColor={subTitleFontColor} setSubTitleFontColor={(val)=>{setSubTitleFontColor(val)}}
//       titleFontWeight={titleFontWeight} setTitleFontWeight={(val)=>{setTitleFontWeight(val)}} 
//     subTitleFontWeight={subTitleFontWeight} setSubTitleFontWeight={(val)=>{setSubTitleFontWeight(val)}}
//    borderRadius={borderRadius}
//      setBorderRadius={(val)=>{setBorderRadius(val)}} marginLeft={marginLeft} setmarginLeft={(val)=>{setmarginLeft(val)}}
//     marginTop={marginTop} setmarginTop={(val)=>{setmarginTop(val)}}  marginBottom={marginBottom} setmarginBottom={(val)=>{setmarginBottom(val)}} 
//     imarginLeft={imarginLeft} setimarginLeft={(val)=>{setimarginLeft(val)}}
//     imarginTop={imarginTop} setimarginTop={(val)=>{setimarginTop(val)}}aspectRatio={aspectRatio} setAspectRatio={(val)=>{setAspectRatio(val)}}
//       showTitle={ showTitle} setShowTitle={(val)=>{ }}
//    showSubTitle={ showSubTitle} setShowSubTitle={(val)=>{ }}
  
    
//     textAlignment={textAlignment} setTextAlignment={(val)=>{ setTextAlignment(val)}}

    
//     textPosition={textPosition} setTextPosition={(val)=>{ setTextPosition(val)}}
//  applyOverlay={applyOverlay} setApplyOverlay={(val)=>{ setApplyOverlay(val)}}
//  overlayTitleFontColor={overlayTitleFontColor} setOverlayTitleFontColor={(val)=>{ setOverlayTitleFontColor(val)}}

//  overlayBG={overlayBG} setOverlayBG={(val)=>{ setOverlayBG(val)}}


//  absoluteHorizontal={absoluteHorizontal} setAbsoluteHorizontal={(val)=>{ setAbsoluteHorizontal(val)}}
//  absoluteVertical={absoluteVertical} setAbsoluteVertical={(val)=>{ setAbsoluteVertical(val)}}
//  absoluteHorizontalMargin={absoluteHorizontalMargin} setAbsoluteHorizontalMargin={(val)=>{ setAbsoluteHorizontalMargin(val)}}
//  absoluteVerticalMargin={absoluteVerticalMargin} setAbsoluteVerticalMargin={(val)=>{ setAbsoluteVerticalMargin(val)}}
// itemVisibility={itemVisibility} setItemVisibility={(val)=>{ setItemVisibility(val)}}

//    itemBackground={itemBackground}   setItemBackground={(val)=>{ setItemBackground(val)}} 
   
   
   />
     :""}
     {
      reloadItems&&  extractElementType(item?.myKey)=="list2"?  
       <ListUI 
       CurrentObject ={item} 
       currentIndex={currentIndex} dynamicId={item?.myKey} 
            setCurrentObject={()=>{setCurrentObject(item?.myKey,item);}}
          
           
     />
     :""}
    
  </div> );
};


export default UIBlockRenderer;
